import type { Locale } from '~/lib/i18n';

import { createContext, use } from 'react';

export const LocaleContext = createContext<Locale | null>(null);

/**
 * @returns The active locale from the nearest LocaleProvider
 */
export function useLocale(): Locale {
  const locale = use(LocaleContext);
  if (null == locale) {
    throw new Error('useLocale must be used within a LocaleProvider');
  }
  return locale;
}
